import { cloneDeep } from 'lodash';
import {
    getCurrentTagGroups,
    setSelectedGroupBySlug,
} from '@domain/segments';
import { createMiddleware } from '@shared/redux';
import {
    closeBudgetManagerCampaignsModal,
    BUDGET_MANAGER_CAMPAIGNS_MODAL_CLOSED,
    setModalDraftClusters,
    setFilters,
} from '@domain/budget-manager/modal/budget-manager-campaigns-modal.state';
import { BUDGET_MANAGER_TEXTS } from '@domain/dashboard/budget-manager/budget-manager.constants';
import { showSuccessToast } from '@shared/toasts';
import {
    getClusters, listClusters, LIST_CLUSTERS_REQUEST_SUCCEEDED,
} from '@domain/omnichannel-budget-manager/clusters';
import {
    MUTATE_CLUSTERS_REQUEST_SUCCEEDED,
    MUTATE_CLUSTERS_REQUEST_FAILED,
} from '@domain/omnichannel-budget-manager/mutate-clusters';
import { getBudgetManagerTagGroup } from '@domain/budget-manager/budget-manager.utils';
import { handleGetTagGroupSegmentedReport } from '@domain/segments/tag-groups-segmented/tag-groups-segmented.state';
import { getLoggedUser } from '@domain/logged-user';
import { getObjectSelectedClient } from '@domain/object-selected';
import { handleBudgetManagerErrorToast } from '@domain/omnichannel-budget-manager/omnichannel-budget-manager.middlewares';

export const budgetManagerCampaignsModalMiddleware = createMiddleware({
    [BUDGET_MANAGER_CAMPAIGNS_MODAL_CLOSED]: state => [
        setFilters({}),
        setModalDraftClusters(cloneDeep(getClusters(state))),
    ],
    [MUTATE_CLUSTERS_REQUEST_SUCCEEDED]: (state) => {
        const segments = getCurrentTagGroups(state);
        const budgetManagerGroup = getBudgetManagerTagGroup(segments?.data);
        const clientId = getObjectSelectedClient(state)?.id;
        const organizationId = getLoggedUser(state)?.company?.id;

        return [
            setFilters({}),
            listClusters({ clientId, organizationId }),
            setSelectedGroupBySlug({ groupSlug: budgetManagerGroup.slug }),
            showSuccessToast({ message: BUDGET_MANAGER_TEXTS.CLUSTERS_SAVED_SUCCESSFULLY }),
            closeBudgetManagerCampaignsModal(),
        ];
    },
    [MUTATE_CLUSTERS_REQUEST_FAILED]: (state, action) => [
        handleBudgetManagerErrorToast(state, action),
    ],
    [LIST_CLUSTERS_REQUEST_SUCCEEDED]: state => [
        handleGetTagGroupSegmentedReport(),
        setModalDraftClusters(cloneDeep(getClusters(state))),
    ],
});
